import axios from "@/http"
export default {
  name:"withinSchool",
  listWithinSchool(param){
    return axios({
      method:"GET",
      url:"/api/v1/information/collegeinter/articles",
      params:param
    })
  },
  getWithinSchool(id){
    return axios({
      url: '/api/v1/information/collegeinter/articles/'+id,
      method: 'GET',
      params: { id,preload: true }
    })
  },
  listWithinSchoolTags(param){
    return axios({
      method:"GET",
      url:"/api/v1/information/collegeinter/tags",
      param
    })
  },
  deleteTagsRelation(param){
    return axios({
      url: '/api/v1/information/collegeinter/relation/articletags',
      method: 'DELETE',
      params: param
    })
  },
  createWithinSchool(param){
    return axios({
      url: '/api/v1/information/collegeinter/articles',
      method: 'POST',
      data:param
    })
  },
  updateWithinSchool(data) {
    return axios({
      url: '/api/v1/information/collegeinter/articles/' + data.id,
      method: 'put',
      params: data.where?{where: data.where}: undefined,
      data
    })
  },

}



// WEBPACK FOOTER //
// ./src/api/axj-information/axj-information-within-school-api.js